/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/no-children-prop */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useEffect, useState } from 'react';
import {
  View,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  Dimensions,
} from 'react-native';
import Divider from '@components/global/Divider';
import ItemDetail from '@components/global/ItemDetail';
import ProductItem from '@components/global/ProductItem';
import SociollaText from '@components/sociolla/SociollaText';
import SearchTable from '@components/table/SearchTable';
import ReturnOrder from '@components/table/ReturnOrder';
import TableMobile from '@components/table/TableMobile';
import ModalSearch from '@components/modal/ModalSearch';
import Button from '@components/form/Button';
import { ButtonSticky } from '@components/screen/Layout';
import AddProduct from '@/screens/transaction/sales-order/components/AddProduct';
import Colors from '@global/colors';
import { isWeb, isNative } from '@global/screens';
import { currency, isQuotationAmountDiff } from '@global/helpers';

const dimension = Dimensions.get('screen');
const actionWidth = dimension.width - 30;

const OrderLines = (props) => {
  const { testID = 'sales-order-lines' } = props;
  const detailData =
    props.detailData && Object.keys(props.detailData).length
      ? props.detailData
      : {};
  const isConfirm = detailData.status == 'need_approval';
  const products = props?.products?.length ? props.products : [];
  const hasOutOfStock = props?.products?.length
    ? props.products.find((pr) => pr.is_out_of_stock)
    : false;
  const skip = props?.skip ? Number(props.skip) : 0;
  const limit = props?.limit ? Number(props.limit) : 0;
  const isQuotation = props?.isQuotation ? Boolean(props.isQuotation) : false;
  const showLoadMore = skip <= products?.length && products?.length >= limit;

  const [focused, setFocused] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [showAddProduct, setShowAddProduct] = useState(false);
  const [productDetail, setProductDetail] = useState({});
  const [RulesTaxTypes, setRulesTaxTypes] = useState('');

  useEffect(() => {
    setKeyword('');
    setRulesTaxTypes(detailData?.price_list?.taxes_type);
  }, []);

  const onShowProductDetail = (data) => {
    if (focused) {
      onCloseSearch();
    }
    setProductDetail(data);
    setShowAddProduct(true);
  };

  const onCloseProductDetail = () => {
    setProductDetail({});
    setShowAddProduct(false);
  };

  const onLoadMoreProducts = () => {
    try {
      props.onLoadMore({ keyword: keyword, skip: skip + limit });
    } catch (error) {}
  };

  const onSearch = (val) => {
    setKeyword(val);
    try {
      props.onSearch({ keyword: val, skip: 0 });
    } catch (error) {}
  };

  const onCloseSearch = () => {
    setFocused(false);
    onSearch();
  };

  const TitleSectionForm = ({ title }) => {
    return (
      <View
        style={{
          width: '100%',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: Colors.grey4,
          paddingHorizontal: 20,
          paddingVertical: 12,
        }}>
        <SociollaText
          type="bold"
          style={{
            fontSize: isWeb ? 16 : 13,
            letterSpacing: 0.5,
            color: Colors.grey1,
          }}>
          {title}
        </SociollaText>
      </View>
    );
  };

  const ButtonLoadMore = ({ title = 'Load More', width = 150, onPress }) => {
    return showLoadMore ? (
      <View
        style={{
          width: '100%',
          paddingVertical: 15,
          alignItems: 'center',
        }}>
        <Button
          testID="sales-order-lines-load-more-btn"
          rounded
          buttonStyle={{ width: width }}
          title={
            <SociollaText
              type="bold"
              style={{
                fontSize: 14,
                letterSpacing: 0.5,
                color: Colors.white,
              }}>
              {title}
            </SociollaText>
          }
          onPress={() => onPress()}
        />
      </View>
    ) : (
      false
    );
  };

  return (
    <View testID={testID} style={{ width: '100%' }}>
      {isWeb ? (
        <View style={{ width: '100%', padding: 15 }}>
          <View
            style={{
              width: '100%',
              paddingBottom: 20,
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}>
            <SearchTable
              testID="sales-order-lines-search"
              onSearch={(val) => onSearch(val)}
              withBorder={true}
              searchPlaceholder="Search products..."
            />
            {detailData.status == 'approved' ? (
              <ReturnOrder
                testID="sales-order-lines-return-order-btn"
                detailData={detailData}
              />
            ) : (
              false
            )}
          </View>
          <ScrollView contentContainerStyle={{ width: '100%' }}>
            {products?.length ? (
              <>
                {products
                  .filter(
                    (item) =>
                      item.product_type !== 'gwp_levelling_free_product',
                  )
                  .map((item, idx) => (
                    <ProductItem
                      key={idx}
                      isQuotation={isQuotation}
                      isCopyItem={true}
                      data={item}
                      withoutDiscount={true}
                      selectedRules={
                        item?.free_product?.id ? item.free_product : {}
                      }
                      isShowStock={
                        detailData?.status === 'need_approval' ||
                        detailData?.status === 'draft' ||
                        detailData?.status === 'quotation'
                      }
                      orderStatus={detailData?.status || ''}
                      isDetail
                      onShow={() => onShowProductDetail(item)}
                      isShowDiscount2={true}
                      // isShowDetailPromo={true}
                    />
                  ))}

                {products.some(
                  (item) => item.product_type === 'gwp_levelling_free_product',
                ) && (
                  <>
                    <TitleSectionForm title="FREE PRODUCT" showButton={false} />
                    {products
                      .filter(
                        (item) =>
                          item.product_type === 'gwp_levelling_free_product',
                      )
                      .map((item, index) => (
                        <ProductItem
                          key={index}
                          isQuotation={isQuotation}
                          isCopyItem={true}
                          data={item}
                          withoutDiscount={true}
                          selectedRules={
                            item?.free_product?.id ? item.free_product : {}
                          }
                          isShowStock={
                            detailData?.status === 'need_approval' ||
                            detailData?.status === 'draft' ||
                            detailData?.status === 'quotation'
                          }
                          orderStatus={detailData?.status || ''}
                          isDetail
                          onShow={() => onShowProductDetail(item)}
                          isShowDiscount2={true}
                          // isShowDetailPromo={true}
                        />
                      ))}
                  </>
                )}
              </>
            ) : (
              <View style={{ width: '100%', paddingVertical: 20 }}>
                <SociollaText>No data found</SociollaText>
              </View>
            )}
            <ButtonLoadMore onPress={() => onLoadMoreProducts()} />
          </ScrollView>
        </View>
      ) : (
        <View>
          <TableMobile
            testID="sales-order-lines-mobile-table"
            placeholder="Search products..."
            isSmall={true}
            onSearch={(value) => onSearch(value)}
            onFocus={() => setFocused(true)}
            tableData={products.filter(
              (item) => item.product_type !== 'gwp_levelling_free_product',
            )}
            renderItem={({ data, index }) => (
              <ProductItem
                testID={`sales-order-lines-product-item-${index}`}
                isCopyItem={true}
                isQuotation={isQuotation}
                data={data}
                withoutDiscount={true}
                selectedRules={data?.free_product?.id ? data.free_product : {}}
                isShowStock={
                  detailData?.status == 'need_approval' ||
                  detailData?.status == 'draft' ||
                  detailData?.status == 'quotation'
                }
                orderStatus={detailData?.status || ''}
                isDetail
                onShow={() => onShowProductDetail(data)}
                key={index}
                isShowDiscount2={true}
                // isShowDetailPromo={true}
              />
            )}
            footerComponent={
              showLoadMore ? (
                <ButtonLoadMore
                  title="See More"
                  width={actionWidth}
                  onPress={() => setFocused(true)}
                />
              ) : (
                false
              )
            }
          />

          {products.some(
            (item) => item.product_type === 'gwp_levelling_free_product',
          ) && (
            <>
              <TitleSectionForm title="FREE PRODUCT" />
              <TableMobile
                showSearch={false}
                notRenderFooter={true}
                placeholder="Search free products..."
                isSmall={true}
                onSearch={(value) => onSearch(value)}
                onFocus={() => setFocused(true)}
                tableData={products.filter(
                  (item) => item.product_type === 'gwp_levelling_free_product',
                )}
                renderItem={({ data, index }) => (
                  <ProductItem
                    isCopyItem={true}
                    isQuotation={isQuotation}
                    data={data}
                    withoutDiscount={true}
                    selectedRules={
                      data?.free_product?.id ? data.free_product : {}
                    }
                    isShowStock={
                      detailData?.status == 'need_approval' ||
                      detailData?.status == 'draft' ||
                      detailData?.status == 'quotation'
                    }
                    orderStatus={detailData?.status || ''}
                    isDetail
                    onShow={() => onShowProductDetail(data)}
                    key={index}
                    isShowDiscount2={true}
                    // isShowDetailPromo={true}
                  />
                )}
              />
            </>
          )}
        </View>
      )}
      <Divider />
      <View
        style={{
          paddingVertical: 10,
          paddingHorizontal: 15,
          ...(isConfirm ? { paddingBottom: !isNative ? 15 : 70 } : {}),
        }}>
        <View style={{ flexDirection: 'row' }}>
          <ItemDetail
            between={true}
            name="Subtotal"
            value={currency(detailData.subtotal, true)}
            valueStyle={{ width: 'unset' }}
          />
        </View>
        {hasOutOfStock ? (
          <ItemDetail
            between={true}
            name="Subtotal PO"
            nameStyle={{ color: Colors.red0 }}
            valueStyle={{ color: Colors.red0, width: 'unset' }}
            value={currency(detailData.subtotal_with_initial_qty || 0, true)}
          />
        ) : (
          false
        )}
        {isQuotation && (
          <ItemDetail
            between={true}
            nameStyle={{
              color: isQuotationAmountDiff(
                detailData.quotation_subtotal,
                detailData.subtotal,
              )
                ? Colors.red0
                : Colors.green1,
            }}
            name="Subtotal Quotation"
            value={currency(detailData.quotation_subtotal, true)}
            valueStyle={{
              color: isQuotationAmountDiff(
                detailData.quotation_subtotal,
                detailData.subtotal,
              )
                ? Colors.red0
                : Colors.green1,
              width: 'unset',
            }}
          />
        )}
        <View style={{ flexDirection: 'row' }}>
          <ItemDetail
            between={true}
            name="Taxes"
            value={currency(detailData.total_tax_amount, true)}
            valueStyle={{ width: 'unset' }}
          />
        </View>
        {hasOutOfStock ? (
          <ItemDetail
            between={true}
            name="Taxes PO"
            nameStyle={{ color: Colors.red0 }}
            valueStyle={{ color: Colors.red0, width: 'unset' }}
            value={currency(
              detailData.total_tax_amount_with_initial_qty || 0,
              true,
            )}
          />
        ) : (
          false
        )}
        {isQuotation && (
          <ItemDetail
            between={true}
            nameStyle={{
              color: isQuotationAmountDiff(
                detailData.quotation_tax,
                detailData.total_tax_amount,
              )
                ? Colors.red0
                : Colors.green1,
            }}
            name="Taxes Quotation"
            value={currency(detailData.quotation_tax, true)}
            valueStyle={{
              color: isQuotationAmountDiff(
                detailData.quotation_tax,
                detailData.total_tax_amount,
              )
                ? Colors.red0
                : Colors.green1,
              width: 'unset',
            }}
          />
        )}
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          <ItemDetail
            between={true}
            name="TOTAL"
            nameBold={true}
            nameStyle={{ color: Colors.blue0 }}
            value={currency(detailData.total_amount, true)}
            valueBold={true}
            valueStyle={{ color: Colors.blue1, width: 'unset' }}
          />
        </View>
        {hasOutOfStock ? (
          <ItemDetail
            between={true}
            name="Total PO"
            nameStyle={{ color: Colors.red0 }}
            valueStyle={{ color: Colors.red0, width: 'unset' }}
            value={currency(
              detailData.total_amount_with_initial_qty || 0,
              true,
            )}
          />
        ) : (
          false
        )}
        {isQuotation && (
          <ItemDetail
            between={true}
            nameStyle={{
              color: isQuotationAmountDiff(
                detailData.quotation_total,
                detailData.total_amount,
              )
                ? Colors.red0
                : Colors.green1,
            }}
            name="TOTAL Quotation"
            value={currency(detailData.quotation_total, true)}
            valueBold={true}
            valueStyle={{
              color: isQuotationAmountDiff(
                detailData.quotation_total,
                detailData.total_amount,
              )
                ? Colors.red0
                : Colors.green1,
              width: 'unset',
            }}
          />
        )}
      </View>
      <AddProduct
        testID={`${testID}-add-product`}
        show={showAddProduct}
        detail={productDetail}
        RulesTaxType={RulesTaxTypes}
        isDetail
        onClose={() => onCloseProductDetail()}
      />
      <ModalSearch
        visible={focused}
        onClose={() => onCloseSearch()}
        children={
          <>
            <TableMobile
              placeholder="Search products..."
              autoFocus={true}
              onSearch={(value) => onSearch(value)}
              tableData={products}
              renderItem={({ data, index }) => (
                <ProductItem
                  data={data}
                  isCopyItem={true}
                  onShow={() => onShowProductDetail(data)}
                  key={index}
                />
              )}
              footerComponent={true}
            />
            <ButtonSticky
              show={focused}
              customHost="modal-sticky-button"
              buttons={[
                {
                  component: (
                    <View style={styles.footerStyle}>
                      <TouchableOpacity
                        style={[
                          styles.closeSearch,
                          {
                            width: showLoadMore ? 100 : actionWidth,
                          },
                        ]}
                        activeOpacity={0.6}
                        onPress={() => onCloseSearch()}>
                        <SociollaText type="bold">Close</SociollaText>
                      </TouchableOpacity>
                      {showLoadMore ? (
                        <Button
                          rounded
                          buttonStyle={{
                            width: actionWidth - 110,
                          }}
                          title={
                            <SociollaText
                              type="bold"
                              style={{
                                fontSize: 14,
                                letterSpacing: 0.5,
                                color: Colors.white,
                              }}>
                              Load More
                            </SociollaText>
                          }
                          onPress={() => onLoadMoreProducts()}
                        />
                      ) : (
                        false
                      )}
                    </View>
                  ),
                },
              ]}
            />
          </>
        }
      />
    </View>
  );
};

const styles = StyleSheet.create({
  footerStyle: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  closeSearch: {
    paddingVertical: 8,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 10,
    borderColor: Colors.grey0,
    borderWidth: 1,
  },
});

export default OrderLines;
